import { Modal } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { useState } from 'react';

import { eliminarPago } from '../../../../actions/pagosProyectos';

const EliminarPagoModal = ({ show, onHide, idPago, idProyecto, onSuccess }) => {
    const dispatch = useDispatch();
    const [saving, setSaving] = useState(false);

    const onConfirm = async () => {
        if (!idPago) {
            onHide();
            return;
        }

        setSaving(true);
        const ok = await dispatch(eliminarPago(idPago, idProyecto));
        setSaving(false);

        if (!ok) return;

        onHide();
        if (typeof onSuccess === 'function') onSuccess();
    };

    return (
        <Modal show={show} onHide={onHide} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Eliminar pago</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div className="alert alert-warning m-0">
                    ¿Estás seguro que deseas eliminar este pago? Esta acción no es reversible.
                </div>
            </Modal.Body>

            <Modal.Footer>
                <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={onHide}
                    disabled={saving}
                >
                    Cancelar
                </button>
                <button
                    type="button"
                    className="btn btn-danger"
                    onClick={onConfirm}
                    disabled={saving}
                >
                    Eliminar
                </button>
            </Modal.Footer>
        </Modal>
    );
};

export default EliminarPagoModal;
